import { getModule, Module, MutationAction, VuexModule, Action } from 'vuex-module-decorators';
import store from '@/store';
import { closeSurvey, defaultMRForm, fetchSurvey, fetchSurveyResponses, fetchUserSurvey, publishSurvey, updateSurveyPath } from '@/store/api';
import { createSurvey, updateSurvey } from '../attachment';

@Module({
  namespaced: true,
  name: 'surveys',
  store,
  dynamic: true,
})
class Surveys extends VuexModule {
  public surveyJson: any = null;
  public defaultsurvey: any | null = null;

  @MutationAction
  public async userSurveyJson() {
    const surveyJson = await fetchUserSurvey('user_feedback');
    return { surveyJson };
  }

  @Action
  public async updateSurvey(survey: any) {
    await updateSurvey(survey);
  }

  @Action
  public async publishSurvey(survey_id: string | number) {
    await publishSurvey(survey_id);
  }

  @Action
  public async updateSurveyPath(survey: any | number) {
    await updateSurveyPath(survey);
  }

  @Action
  public async getSurvey(survey_id: string | number) {
    await fetchSurvey(survey_id)
  }

  @Action
  public async closeSurvey(survey_id: string | number) {
    await closeSurvey(survey_id);
  }

  @Action
  public async createASurvey(survey: any) {
    await createSurvey(survey);
  }

  @Action
  public async surveyResponses(surveyId: number | string) {
    await fetchSurveyResponses(surveyId);
  }

  @MutationAction
  public async getDefaultSurveyForm(type: string) {
    const defaultsurvey = await defaultMRForm(type);
    return { defaultsurvey };
  }

}

export default getModule(Surveys);
